module.exports = __webpack_public_path__ + "img/26.a017d846.jpg";